<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <b-tabs justified>
            <b-tab title="Información del Cliente" active>
              <b-form>
                <b-form-group
                  label="Razón Social"
                  label-for="razonSocial"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="razonSocial"
                    v-model.trim="$v.razonSocial.$model" 
                    :state="razonSocialValida"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="razonSocialFeedback">
                    {{ razonSocialInvalidaMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Nombre Comercial"
                  label-for="nombreComercial"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="nombreComercial"
                    v-model.trim="$v.nombreComercial.$model" 
                    :state="nombreComercialValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="nombreComercialFeedback">
                    {{ nombreComercialInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <app-condicion-fiscal
                  label="Cond.Fiscal"
                  :nombre="condicionFiscalNombre"
                  :lista="condicionesFiscalesList"
                  :valido="condicionFiscalValida"
                  :msjInvalido="condicionFiscalInvalidaMsj"
                  :labelCols="labelCols"
                  @validate="validate"
                  @updated="condicionFiscalActualizada">
                </app-condicion-fiscal>  

                <app-documento-tipo
                  label="Tipo Identificación"
                  :nombre="documentoTipoNombre"
                  :lista="documentosTiposList"
                  :valido="documentoTipoValido"
                  :msjInvalido="documentoTipoInvalidoMsj"
                  :labelCols="labelCols"
                  @validate="validate"
                  @updated="documentoTipoActualizado">
                </app-documento-tipo>  

                <b-form-group
                  label="Cod.Identificación"
                  label-for="documentoNumero"
                  :label-cols="labelCols"
                  description="Código de identificación tributaria (CUIT, CIF, TIN\EIN, etc). En caso de CUIT, ingrese sólo dígitos numéricos."
                  horizontal>
                  <b-form-input 
                    id="documentoNumero"
                    v-model.trim="$v.documentoNumero.$model" 
                    :state="documentoNumeroValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="documentoNumeroFeedback">
                    {{ documentoNumeroInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <app-giro-empresa
                  v-if="giroEmpresaVisible"
                  label="Giro Empresa"
                  :nombre="giroEmpresaNombre"
                  :lista="girosEmpresasList"
                  :valido="giroEmpresaValido"
                  :msjInvalido="giroEmpresaInvalidoMsj"
                  :labelCols="labelCols"
                  @validate="validate"
                  @updated="giroEmpresaActualizado">
                </app-giro-empresa>  

                <b-form-group
                  label="Dirección"
                  label-for="direccion"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="direccion"
                    v-model.trim="$v.direccion.$model" 
                    :state="direccionValida"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="direccionFeedback">
                    {{ direccionInvalidaMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <app-pais
                  label="Pais"
                  :nombre="paisNombre"
                  :lista="paisesList"
                  :valido="paisValido"
                  :msjInvalido="paisInvalidoMsj"
                  :labelCols="labelCols"
                  @validate="validate"
                  @updated="paisActualizado">
                </app-pais>  

                <app-provincia
                  label="Provincia"
                  :nombre="provinciaNombre"
                  :lista="provinciasList"
                  :valido="provinciaValida"
                  :msjInvalido="provinciaInvalidaMsj"
                  :labelCols="labelCols"
                  @validate="validate"
                  @updated="provinciaActualizada">
                </app-provincia>  

                <app-localidad
                  label="Localidad"
                  :nombre="localidadNombre"
                  :lista="localidadesList"
                  :valido="localidadValida"
                  :msjInvalido="localidadInvalidaMsj"
                  :labelCols="labelCols"
                  @validate="validate"
                  @updated="localidadActualizada">

                  <div class="custom-select-add" 
                    v-if="accesoLocalidadesABM"
                    @click.prevent="addLocalidad">
                      <i class="fa fa-plus" aria-hidden="true"></i>
                  </div>
                </app-localidad>  

                <b-form-group
                  label="Cod.Postal"
                  label-for="codigoPostal"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="codigoPostal"
                    v-model.trim="$v.codigoPostal.$model" 
                    :state="codigoPostalValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="codigoPostalFeedback">
                    {{ codigoPostalInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
                
                <b-form-group
                  label="Teléfono"
                  label-for="telefono"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="telefono"
                    v-model.trim="$v.telefono.$model" 
                    :state="telefonoValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="telefonoFeedback">
                    {{ telefonoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
                
                <b-form-group
                  label="Celular"
                  label-for="celular"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="celular"
                    v-model.trim="$v.celular.$model" 
                    :state="celularValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="celularFeedback">
                    {{ celularInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
                
                <b-form-group
                  label="Email"
                  label-for="email"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="email"
                    v-model.trim="$v.email.$model" 
                    :state="emailValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="emailFeedback">
                    {{ emailInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
                
                <b-form-group
                  label="Email"
                  label-for="email2"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="email2"
                    v-model.trim="$v.email2.$model" 
                    :state="email2Valido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="email2Feedback">
                    {{ email2InvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Nro.Proveedor"
                  label-for="numeroProveedor"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="numeroProveedor"
                    v-model.trim="$v.numeroProveedor.$model" 
                    :state="numeroProveedorValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="numeroProveedorFeedback">
                    {{ numeroProveedorInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  :label-cols="labelCols"
                  label-for="grandesContribuyentes"
                  horizontal>
                  <b-form-checkbox 
                      id="grandesContribuyentes"
                      v-model="grandesContribuyentes"
                      value= true
                      unchecked-value= false>
                      Grandes Contribuyentes (FCE MiPyME)
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  :label-cols="labelCols"
                  label-for="sistemaCirculacionAbierta"
                  description="Por defecto la opción es Agente de Depósito Colectivo"
                  horizontal>
                  <b-form-checkbox 
                      id="sistemaCirculacionAbierta"
                      v-model="sistemaCirculacionAbierta"
                      value= true
                      unchecked-value= false>
                      Sistema de Circulación Abierta (FCE MiPyME)
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="inactivo"
                      v-model="inactivo"
                      value= true
                      unchecked-value= false>
                      Inactivo
                  </b-form-checkbox>
                </b-form-group>
              </b-form>
            </b-tab>
            <b-tab title="Configuración de Presupuestación">
              <b-form>
                <app-forma-pago
                  label="Forma de Pago"
                  :nombre="formaPagoNombre"
                  :lista="formasPagoList"
                  :valido="formaPagoValida"
                  :msjInvalido="formaPagoInvalidaMsj"
                  :labelCols="labelCols"
                  @validate="validate"
                  @updated="formaPagoActualizada">
                </app-forma-pago>  

                <b-form-group
                  label="Plazo de Pago"
                  label-for="plazoPago"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="plazoPago"
                    v-model.trim="$v.plazoPago.$model" 
                    :state="plazoPagoValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="plazoPagoFeedback">
                    {{ plazoPagoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <br/>
                <!-- <hr> -->
                <br/>

                <b-form-group
                  label="Fee Agencia"
                  label-for="feeAgencia"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="feeAgencia"
                    v-model.trim="$v.feeAgencia.$model" 
                    :state="feeAgenciaValido"
                    type="text"
                    :readonly="aplicarEscalaFee"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="feeAgenciaFeedback">
                    {{ feeAgenciaInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
                
                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="aplicarEscalaFee"
                      v-model="aplicarEscalaFee"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                      Aplicar Escala de Porcentajes de Fee
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  :label-cols="labelCols"
                  description="Montos mínimos y máximos con respecto a la cotización total del presupuesto sin fee."
                  horizontal>
                  <b-table hover
                      responsive="sm" 
                      class="registro"
                      :busy="tableBusy"
                      :items="escalasFee" 
                      :fields="escalasFeeFields">
                    <template v-slot:cell(montoMinimo)="data">
                      <template v-if="data.item.montoMinimo == 0">
                        ---.--
                      </template>
                      <template v-if="data.item.montoMinimo != 0">
                        {{ data.item.montoMinimo | moneda }}
                      </template>
                    </template>
                    <template v-slot:cell(montoMaximo)="data">
                      <template v-if="data.item.montoMaximo == 0">
                        ---.--
                      </template>
                      <template v-if="data.item.montoMaximo != 0">
                        {{ data.item.montoMaximo | moneda }}
                      </template>
                    </template>
                    <template v-slot:cell(pjeFeeAgencia)="data">
                      {{ data.item.pjeFeeAgencia | porcentaje }}
                    </template>
                    <template v-slot:cell(opciones)="data">
                      <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                        <template slot="button-content">
                          <i class="fa fa-ellipsis-v"></i>
                        </template>
                        <b-dropdown-item 
                            :disabled="!aplicarEscalaFee"
                            @click.stop="editarEscalaFee(data.item)">
                          <i class="fa fa-edit"></i>Editar Escala</b-dropdown-item>
                        <b-dropdown-item 
                            :disabled="!aplicarEscalaFee"
                            @click.stop="eliminarEscalaFee(data.item)">
                          <i class="fa fa-remove"></i>Eliminar Escala</b-dropdown-item>
                      </b-dropdown>
                    </template>
                  </b-table>
                  <div class="add-table-btn" v-if="aplicarEscalaFee">
                    <div class="list-add-btn" @click.prevent="agregarEscalaFee">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                    </div>
                  </div>
                </b-form-group>

                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="discriminarFeePresupuesto"
                      v-model="discriminarFeePresupuesto"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                      Discriminar Fee en Presupuestos
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="ocultarLeyendaFeePresupuesto"
                      v-model="ocultarLeyendaFeePresupuesto"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)"
                      :disabled="discriminarFeePresupuesto">
                      Ocultar Leyenda Fee en Presupuestos
                  </b-form-checkbox>
                </b-form-group>

                <!-- <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="feeComisionable"
                      v-model="feeComisionable"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                      Fee Comisionable
                  </b-form-checkbox>
                </b-form-group> -->

                <br/>
                <!-- <hr> -->
                <br/>
                
                <b-form-group
                  label="Fee Rubros Diferenciados"
                  label-for="feeAgenciaPremios"
                  :label-cols="labelCols"
                  description="Fee de Agencia para rubros diferenciados (configurar en solapa Fee Rubros Diferenciados)"
                  horizontal>
                  <b-form-input 
                    id="feeAgenciaPremios"
                    v-model.trim="$v.feeAgenciaPremios.$model" 
                    :state="feeAgenciaPremiosValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="feeAgenciaPremiosFeedback">
                    {{ feeAgenciaPremiosInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="discriminarFeePremios"
                      v-model="discriminarFeePremios"
                      :value= "Boolean(true)"
                      :unchecked-value= "Boolean(false)">
                      Fee de Rubros Diferenciados Discriminado
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="prontoPagoFeeDiferenciado"
                      v-model="prontoPagoFeeDiferenciado"
                      :value= "Boolean(true)"
                      :unchecked-value= "Boolean(false)">
                      Pronto Pago en Órdenes con Fee de Rubros Diferenciado
                  </b-form-checkbox>
                </b-form-group>

                <br/>
                <!-- <hr> -->
                <br/>

                <b-form-group
                  label="Pje Financiacion"
                  label-for="pjeFinanciacion"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="pjeFinanciacion"
                    v-model.trim="$v.pjeFinanciacion.$model" 
                    :state="pjeFinanciacionValido"
                    type="text"
                    :readonly="aplicarEscalaFinanciacion"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="pjeFinanciacionFeedback">
                    {{ pjeFinanciacionInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="aplicarEscalaFinanciacion"
                      v-model="aplicarEscalaFinanciacion"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                      Aplicar Escala de Porcentajes de Financiacion
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  :label-cols="labelCols"
                  description="Montos mínimos y máximos con respecto a la cotización total del presupuesto sin fee."
                  horizontal>
                  <b-table hover
                      responsive="sm" 
                      class="registro"
                      :busy="tableBusy"
                      :items="escalasFinanciacion" 
                      :fields="escalasFinanciacionFields">
                    <template v-slot:cell(montoMinimo)="data">
                      <template v-if="data.item.montoMinimo == 0">
                        ---.--
                      </template>
                      <template v-if="data.item.montoMinimo != 0">
                        {{ data.item.montoMinimo | moneda }}
                      </template>
                    </template>
                    <template v-slot:cell(montoMaximo)="data">
                      <template v-if="data.item.montoMaximo == 0">
                        ---.--
                      </template>
                      <template v-if="data.item.montoMaximo != 0">
                        {{ data.item.montoMaximo | moneda }}
                      </template>
                    </template>
                    <template v-slot:cell(pjeFinanciacion)="data">
                      {{ data.item.pjeFinanciacion | porcentaje }}
                    </template>
                    <template v-slot:cell(opciones)="data">
                      <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                        <template slot="button-content">
                          <i class="fa fa-ellipsis-v"></i>
                        </template>
                        <b-dropdown-item 
                            :disabled="!aplicarEscalaFinanciacion"
                            @click.stop="editarEscalaFinanciacion(data.item)">
                          <i class="fa fa-edit"></i>Editar Escala</b-dropdown-item>
                        <b-dropdown-item 
                            :disabled="!aplicarEscalaFinanciacion"
                            @click.stop="eliminarEscalaFinanciacion(data.item)">
                          <i class="fa fa-remove"></i>Eliminar Escala</b-dropdown-item>
                      </b-dropdown>
                    </template>
                  </b-table>
                  <div class="add-table-btn" v-if="aplicarEscalaFinanciacion">
                    <div class="list-add-btn" @click.prevent="agregarEscalaFinanciacion">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                    </div>
                  </div>
                </b-form-group>

                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="discriminarPjeFinanciacion"
                      v-model="discriminarPjeFinanciacion"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                      Discriminar Pje de Financiacion
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="feeSobreFinanciacion"
                      v-model="feeSobreFinanciacion"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                      Aplicar Fee sobre Pje de Financiacion
                  </b-form-checkbox>
                </b-form-group>

                <br/>
                <!-- <hr> -->
                <br/>

                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="discriminarCategoriaServicio"
                      v-model="discriminarCategoriaServicio"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                      Discriminar Categoría de Servicio en Presupuestos
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="servicioPropioNoAplicaFee"
                      v-model="servicioPropioNoAplicaFee"
                      :value= "Boolean(true)"
                      :unchecked-value= "Boolean(false)"
                      :disabled="!discriminarCategoriaServicio">
                      No Aplica Fee en Servicios Propios
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  
                  label="Pje Recargo"
                  label-for="pjeRecargoServicioPropio"
                  :label-cols="labelCols"
                  description="Pje de Recargo sobre trabajos de servicio propio"
                  horizontal>
                  <b-form-input 
                    id="pjeRecargoServicioPropio"
                    v-model.trim="$v.pjeRecargoServicioPropio.$model" 
                    :state="pjeRecargoServicioPropioValido"
                    :disabled="!discriminarCategoriaServicio"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="pjeRecargoServicioPropioFeedback">
                    {{ pjeRecargoServicioPropioInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <br/>

                <b-form-group
                  v-if="!discriminarCategoriaServicio"
                  label="Pje Margen Mínimo"
                  label-for="pjeMargenMinimoCotizacion"
                  :label-cols="labelCols"
                  description="Margen mínimo sobre el costo interno"
                  horizontal>
                  <b-form-input 
                    id="pjeMargenMinimoCotizacion"
                    v-model.trim="$v.pjeMargenMinimoCotizacion.$model" 
                    :state="pjeMargenMinimoCotizacionValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="pjeMargenMinimoCotizacionFeedback">
                    {{ pjeMargenMinimoCotizacionInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  v-if="discriminarCategoriaServicio"
                  label="Pje Margen Mínimo"
                  label-for="pjeMargenMinimoCotizacionPropio"
                  :label-cols="labelCols"
                  description="Margen mínimo sobre el costo interno para trabajos de servicio propio"
                  horizontal>
                  <b-form-input 
                    id="pjeMargenMinimoCotizacionPropio"
                    v-model.trim="$v.pjeMargenMinimoCotizacionPropio.$model" 
                    :state="pjeMargenMinimoCotizacionPropioValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="pjeMargenMinimoCotizacionPropioFeedback">
                    {{ pjeMargenMinimoCotizacionPropioInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  v-if="discriminarCategoriaServicio"
                  label="Pje Margen Mínimo"
                  label-for="pjeMargenMinimoCotizacionTerceros"
                  :label-cols="labelCols"
                  description="Margen mínimo sobre el costo interno para trabajos de servicio de terceros"
                  horizontal>
                  <b-form-input 
                    id="pjeMargenMinimoCotizacionTerceros"
                    v-model.trim="$v.pjeMargenMinimoCotizacionTerceros.$model" 
                    :state="pjeMargenMinimoCotizacionTercerosValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="pjeMargenMinimoCotizacionTercerosFeedback">
                    {{ pjeMargenMinimoCotizacionTercerosInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <br/>
                <hr>
                <br/>

                <b-form-group
                  v-if="accesoParametrosCostoInterno"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="parametrosCostoInterno"
                      v-model="parametrosCostoInterno"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                      Parámetros Costo Interno Propios
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  v-if="accesoParametrosCostoInterno"
                  label="Pje Gastos Fijos"
                  label-for="pjeGastosFijos"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="pjeGastosFijos"
                    v-model.trim="$v.pjeGastosFijos.$model" 
                    :state="pjeGastosFijosValido"
                    :disabled="!parametrosCostoInterno"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="pjeGastosFijosFeedback">
                    {{ pjeGastosFijosInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  v-if="accesoParametrosCostoInterno"
                  label="Pje Inversión Futura"
                  label-for="pjeInversionFutura"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="pjeInversionFutura"
                    v-model.trim="$v.pjeInversionFutura.$model" 
                    :state="pjeInversionFuturaValido"
                    :disabled="!parametrosCostoInterno"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="pjeInversionFuturaFeedback">
                    {{ pjeInversionFuturaInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  v-if="accesoParametrosCostoInterno"
                  label="Pje Impuestos Internos"
                  label-for="pjeImpuestosInternos"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="pjeImpuestosInternos"
                    v-model.trim="$v.pjeImpuestosInternos.$model" 
                    :state="pjeImpuestosInternosValido"
                    :disabled="!parametrosCostoInterno"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="pjeImpuestosInternosFeedback">
                    {{ pjeImpuestosInternosInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <br/>
                <hr>
                <br/>

                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="seleccionProvinciasPresupuestos"
                      v-model="seleccionProvinciasPresupuestos"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                      Debe Seleccionar Provincias Asociadas al Presupuesto
                  </b-form-checkbox>
                </b-form-group>
              </b-form>
            </b-tab>

            <b-tab title="Observaciones">
              <b-form>
                <b-form-group>
                  <b-form-textarea
                    id="observaciones"
                    v-model="$v.observaciones.$model" 
                    rows="50"
                    max-rows="50"
                    :state="observacionesValidas"
                    @blur.native="validate">
                  </b-form-textarea>
                  <b-form-invalid-feedback id="observacionesFeedback">
                    {{ observacionesInvalidasMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-form>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="escalaFeeModal"
        title="Escala Fee de Agencia"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-escala-fee
        :escalaFee="escalaFee"
        :escalas="escalasFee"
        @updateEscalaFee="updateEscalaFee"
        @close="closeEscalaFee">
      </app-escala-fee>  
    </b-modal>

    <b-modal ref="escalaFinanciacionModal"
        title="Escala Financiacion"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-escala-financiacion
        :escalaFinanciacion="escalaFinanciacion"
        :escalas="escalasFinanciacion"
        @updateEscalaFinanciacion="updateEscalaFinanciacion"
        @close="closeEscalaFinanciacion">
      </app-escala-financiacion>  
    </b-modal>

    <b-modal ref="localidadModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM">
      <app-alta-localidad
        :provincia="provincia" 
        @updateLocalidades="updateLocalidades"
        @closeLocalidad="closeLocalidad">
      </app-alta-localidad>  
    </b-modal>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import CondicionFiscal from '../shared/abmSelect.vue';
import DocumentoTipo from '../shared/abmSelect.vue';
import Pais from '../shared/abmSelect.vue';
import Provincia from '../shared/abmSelect.vue';
import Localidad from '../shared/abmSelect.vue';
import GiroEmpresa from '../shared/abmSelect.vue';
import FormaPago from '../shared/abmSelect.vue';
import AltaLocalidad from '../localidades/modalABM.vue';
import EscalaFee from  './EscalaFee.vue';
import EscalaFinanciacion from  './EscalaFinanciacion.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, requiredIf, decimal, numeric, maxLength, email, minValue, maxValue, helpers } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'cliente/getField',
  mutationType: 'cliente/updateField',
});

const DocumentoValido = ((value, vm) => {
  if (value == '') {
    return true;
  } else {

    /* Sólo validamos el formato del CUIT */
    let isValid = true;
    switch (vm.documentoTipoId) {
      case 2:
        /* Cuit (11 digitos numéricos) */
        if (isNaN(parseInt(value))) {
          isValid = false;
        } else {
          let length = Math.log(value) * Math.LOG10E + 1 | 0;  
          if (length != 0 & length != 11) {
            isValid = false;
          }
        }
        break;

      // case 4:
      //   /* TIN / EIN  (9 digitos numéricos) */
      //   if (isNaN(parseInt(value))) {
      //     isValid = false;
      //   } else {
      //     let length = Math.log(value) * Math.LOG10E + 1 | 0;  
      //     if (length != 0 & length != 9) {
      //       isValid = false;
      //     }
      //   }
      //   break;
    }
    return isValid;
  }
})

export default {
  name: 'ABM',
  components: {
    appABMButton: ABMButtons,
    appCondicionFiscal: CondicionFiscal,
    appDocumentoTipo: DocumentoTipo,
    appPais: Pais,
    appProvincia: Provincia,
    appLocalidad: Localidad,
    appAltaLocalidad: AltaLocalidad,
    appGiroEmpresa: GiroEmpresa,
    appFormaPago: FormaPago,
    appEscalaFee: EscalaFee,
    appEscalaFinanciacion: EscalaFinanciacion,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      modalMensaje: '',
      modalMsj: false,
      modalOkAction: null,
      modalHiddenAction: null,
      loadingPaises: false,
      loadingProvincias: false,

      noValidar: true,
      nombreComercialValido: null,
      nombreComercialInvalidoMsj: '',
      razonSocialValida: null,
      razonSocialInvalidaMsj: '',
      condicionFiscalValida: null,
      condicionFiscalInvalidaMsj: '',
      documentoTipoValido: null,
      documentoTipoInvalidoMsj: '',
      documentoNumeroValido: null,
      documentoNumeroInvalidoMsj: '',
      giroEmpresaValido: null,
      giroEmpresaInvalidoMsj: '',
      direccionValida: null,
      direccionInvalidaMsj: '',
      codigoPostalValido: null,
      codigoPostalInvalidoMsj: '',
      telefonoValido: null,
      telefonoInvalidoMsj: '',
      celularValido: null,
      celularInvalidoMsj: '',
      emailValido: null,
      emailInvalidoMsj: '',
      email2Valido: null,
      email2InvalidoMsj: '',
      feeAgenciaValido: null,
      feeAgenciaInvalidoMsj: '',
      feeAgenciaPremiosValido: null,
      feeAgenciaPremiosInvalidoMsj: '',
      pjeFinanciacionValido: null,
      pjeFinanciacionInvalidoMsj: '',
      pjeRecargoServicioPropioValido: null,
      pjeRecargoServicioPropioInvalidoMsj: '',
      pjeMargenMinimoCotizacionValido: null,
      pjeMargenMinimoCotizacionInvalidoMsj: '',
      pjeMargenMinimoCotizacionPropioValido: null,
      pjeMargenMinimoCotizacionPropioInvalidoMsj: '',
      pjeMargenMinimoCotizacionTercerosValido: null,
      pjeMargenMinimoCotizacionTercerosInvalidoMsj: '',
      pjeGastosFijosValido: null,
      pjeGastosFijosInvalidoMsj: '',
      pjeInversionFuturaValido: null,
      pjeInversionFuturaInvalidoMsj: '',
      pjeImpuestosInternosValido: null,
      pjeImpuestosInternosInvalidoMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',
      paisValido: null,
      paisInvalidoMsj: '',
      provinciaValida: null,
      provinciaInvalidaMsj: '',
      localidadValida: null,
      localidadInvalidaMsj: '',
      formaPagoValida: null,
      formaPagoInvalidaMsj: '',
      plazoPagoValido: null,
      plazoPagoInvalidoMsj: '',
      numeroProveedorValido: null,
      numeroProveedorInvalidoMsj: '',

      localidades: [],
      localidadesList: [],
      provincias: [],
      provinciasList: [],
      paises: [],
      paisesList: [],
      condicionesFiscales: [],
      condicionesFiscalesList: [],
      documentosTipos: [],
      documentosTiposList: [],
      formasPago: [],
      formasPagoList: [],
      girosEmpresas: [],
      girosEmpresasList: [],

      tableBusy: false,
      escalasFeeFields: [
        { key: 'montoMinimo' },
        { key: 'montoMaximo' },
        { key: 'pjeFeeAgencia' },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],
      escalasFinanciacionFields: [
        { key: 'montoMinimo' },
        { key: 'montoMaximo' },
        { key: 'pjeFinanciacion' },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],
      escalaFee: null,
      escalaFinanciacion: null,

      labelCols: 2,

      accesoLocalidadesABM: false,
      accesoParametrosCostoInterno: false
    }
  },
  computed: {
    ...mapFields([
      'id',
      'nombreComercial',
      'razonSocial',
      'condicionFiscal',
      'documentoTipoId',
      'documentoTipo',
      'documentoTipoNombre',
      'documentoNumero',
      'giroEmpresa',
      'giroEmpresaNombre',
      // 'cuit',
      'direccion',
      'pais',
      'provincia',
      'localidad',
      'codigoPostal',
      'telefono',
      'celular',
      'email',
      'email2',
      'feeAgencia',
      'aplicarEscalaFee',
      'feeAgenciaPremios',
      'discriminarFeePresupuesto',
      'ocultarLeyendaFeePresupuesto',
      'discriminarFeePremios',
      // 'feeComisionable',
      'pjeFinanciacion',
      'aplicarEscalaFinanciacion',
      'discriminarPjeFinanciacion',
      'feeSobreFinanciacion',
      'discriminarCategoriaServicio',
      'servicioPropioNoAplicaFee',
      'prontoPagoFeeDiferenciado',
      'pjeRecargoServicioPropio',
      'pjeMargenMinimoCotizacion',
      'pjeMargenMinimoCotizacionPropio',
      'pjeMargenMinimoCotizacionTerceros',
      'parametrosCostoInterno',
      'pjeGastosFijos',
      'pjeInversionFutura',
      'pjeImpuestosInternos',
      'inactivo',
      'paisNombre',
      'provinciaNombre',
      'localidadNombre',
      'condicionFiscalNombre',
      'observaciones',
      'formaPago',
      'formaPagoNombre',
      'plazoPago',
      'numeroProveedor',
      'grandesContribuyentes',
      'sistemaCirculacionAbierta',
      'seleccionProvinciasPresupuestos',
      'escalasFee',
      'escalasFinanciacion',
      'giroEmpresaVisible'
    ])
  },  
  created() {
    let clienteId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        clienteId = this.$route.params.id
      }
    }

    let userRolId = this.$store.getters['user/rolId'];
    switch (userRolId) {
      case 1:
        this.accesoLocalidadesABM = true;  
        this.accesoParametrosCostoInterno = true;
        break;

      case 2:
      case 6:
      case 8:
      case 9:
        this.accesoParametrosCostoInterno = true;
        break;
    }

    this.loadingPaises = true;
    this.loadingProvincias = true;

    this.showSpinner();
    this.$store.dispatch('cliente/inicializar', clienteId)
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      const vm = this;
      
      this.$store.dispatch('paises/getPaisesSelect')
        .then(() => {
          vm.paises = this.$store.getters['paises/paisesSelect'];
          vm.paisesList = this.$store.getters['paises/listSelect'];
          vm.loadingPaises = false;
          return;
        })
        .then (() => this.getProvincias())
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de paises.'));

      this.$store.dispatch('condicionesfiscales/getCondicionesFiscales')
        .then(() => {
          vm.condicionesFiscales = this.$store.getters['condicionesfiscales/list']
          vm.condicionesFiscalesList = this.$store.getters['condicionesfiscales/selectList']
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de condiciones fiscales.'));

      this.$store.dispatch('documentostipos/getList')
        .then(() => {
          vm.documentosTipos = this.$store.getters['documentostipos/list']
          vm.documentosTiposList = this.$store.getters['documentostipos/selectList']
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de tipos de identificación.'));

      this.$store.dispatch('formaspago/getList')
        .then(() => {
          vm.formasPago = this.$store.getters['formaspago/list'];
          vm.formasPagoList = this.$store.getters['formaspago/selectList'];
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de formas de pago.'));
      
      if (this.giroEmpresaVisible) {
        this.$store.dispatch('girosEmpresas/getList')
          .then(() => {
            vm.girosEmpresas = this.$store.getters['girosEmpresas/list'];
            vm.girosEmpresasList = this.$store.getters['girosEmpresas/selectList'];
          })
          .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de giros de empresas'));

      }
    },
    getProvincias() {
      this.provincias = [];
      this.provinciasList = [];

      if (this.paisNombre)
      {
        let pais = this.getSelected(this.paises, this.paisNombre);
        if (pais)
        {
          this.$store.dispatch('provincias/getList', pais.id)
            .then(() => {
              this.provincias = this.$store.getters['provincias/list']
              this.provinciasList = this.$store.getters['provincias/selectList']
              this.loadingProvincias = false;
            })
            .then (() => this.getLocalidades())
            .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de provincias.'));
        }
      }
    },
    getLocalidades() {
      this.localidades = [];
      this.localidadesList = [];

      if (this.provinciaNombre)
      {
        var provincia = this.getSelected(this.provincias, this.provinciaNombre);
        if (provincia)
        {
          this.$store.dispatch('localidades/getLocalidadesProvincia', provincia.id)
            .then(() => {
              this.localidades = this.$store.getters['localidades/localidadesProvincia'];
              this.localidadesList = this.$store.getters['localidades/localidadesProvinciaList'];
            })
            .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de localidades.'));
        }
      }
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'nombreComercial' || validarTodos) {
        if (this.$v.nombreComercial.$error) {
          this.nombreComercialValido = false;
          if (!this.$v.nombreComercial.required) {
            this.nombreComercialInvalidoMsj= 'Debe ingresar el nombre comercial del cliente';
          } else if (!this.$v.nombreComercial.maxLength) {
            this.nombreComercialInvalidoMsj = 'El nombre comercial solo puede contener hasta 75 caracteres';
          } 
        } else {
          this.nombreComercialValido = null;
          this.nombreComercialInvalidoMsj = '';
        }
      }
        
      if (campo == 'razonSocial' || validarTodos) {
        if (this.$v.razonSocial.$error) {
          this.razonSocialValida = false;
          if (!this.$v.razonSocial.required) {
            this.razonSocialInvalidaMsj = 'Debe ingresar la razón social del cliente';
          } else if (!this.$v.razonSocial.maxLength) {
            this.razonSocialInvalidaMsj = 'La razón social solo puede contener hasta 75 caracteres';
          }
        } else {
          this.razonSocialValida = null;
          this.razonSocialInvalidaMsj = '';
        }
      }
        
      if (campo == 'documentoNumero' || validarTodos) {
        if (this.$v.documentoNumero.$error) {
          this.documentoNumeroValido = false;
          if (!this.$v.documentoNumero.required) {
            this.documentoNumeroInvalidoMsj = 'Debe ingresar el código de identificación del cliente';
          } else if (!this.$v.documentoNumero.DocumentoValido) {
            this.documentoNumeroInvalidoMsj = 'Verifique por favor el código de identificación ingresado';
          } else if (!this.$v.documentoNumero.maxLength) {
            this.documentoNumeroInvalidoMsj = 'El código de identificación solo puede contener hasta 20 caracteres';
          }      
        } else {
          this.documentoNumeroValido = null;
          this.documentoNumeroInvalidoMsj = '';
        }
      }

      // if (campo == 'cuit' || validarTodos) {
      //   if (this.$v.cuit.$error) {
      //     this.cuitValido = false;
      //     if (!this.$v.cuit.required) {
      //       this.cuitInvalidoMsj = 'Debe ingresar el CUIT del cliente';
      //     } else if (!this.$v.cuit.CUIT) {
      //       this.cuitInvalidoMsj = 'Verifique por favor el CUIT ingresado';
      //     } else if (!this.$v.cuit.numeric) {
      //       this.cuitInvalidoMsj = 'El CUIT del cliente solo puede contener números';
      //     }      
      //   } else {
      //     this.cuitValido = null;
      //     this.cuitInvalidoMsj = '';
      //   }
      // }

      if (campo == 'direccion' || validarTodos) {
        if (this.$v.direccion.$error) {
          this.direccionValida = false;
          if (!this.$v.direccion.maxLength) {
            this.direccionInvalidaMsj = 'La dirección solo puede contener hasta 150 caracteres';
          }      
        } else {
          this.direccionValida = null;
          this.direccionInvalidaMsj = '';
        }
      }

      if (campo == 'codigoPostal' || validarTodos) {
        if (this.$v.codigoPostal.$error) {
          this.codigoPostalValido = false;
          if (!this.$v.codigoPostal.maxLength) {
            this.codigoPostalInvalidoMsj = 'El código postal solo puede contener hasta 8 caracteres';
          }      
        } else {
          this.codigoPostalValido = null;
          this.codigoPostalInvalidoMsj = '';
        }
      }

      if (campo == 'telefono' || validarTodos) {
        if (this.$v.telefono.$error) {
          this.telefonoValido = false;
          if (!this.$v.telefono.maxLength) {
            this.telefonoInvalidoMsj = 'El número de teléfono solo puede contener hasta 50 caracteres';
          }      
        } else {
          this.telefonoValido = null;
          this.telefonoInvalidoMsj = '';
        }
      }
          
      if (campo == 'celular' || validarTodos) {
        if (this.$v.celular.$error) {
          this.celularValido = false;
          if (!this.$v.celular.maxLength) {
            this.celularInvalidoMsj = 'El número de celular solo puede contener hasta 50 caracteres';
          }      
        } else {
          this.celularValido = null;
          this.celularInvalidoMsj = '';
        }
      }

      if (campo == 'email' || validarTodos) {
        if (this.$v.email.$error) {
          this.emailValido = false
          if (!this.$v.email.email) {
            this.emailInvalidoMsj = 'El email ingresado no parece ser una dirección de correo válida';
          }      
        } else {
          this.emailValido = null;
          this.emailInvalidoMsj = '';
        }
      }
          
      if (campo == 'email2' || validarTodos) {
        if (this.$v.email2.$error) {
          this.email2Valido = false;
          if (!this.$v.email2.email) {
            this.email2InvalidoMsj = 'El email ingresado no parece ser una dirección de correo válida';
          }      
        } else {
          this.email2Valido = null;
          this.email2InvalidoMsj = '';
        }
      }

      if (campo == 'feeAgencia' || validarTodos) {
        if (this.$v.feeAgencia.$error) {
          this.feeAgenciaValido = false;
          if (!this.$v.feeAgencia.decimal) {
            this.feeAgenciaInvalidoMsj = 'El fee de agencia debe ser un valor numérico';
          } else {
            if (!this.$v.feeAgencia.maxValue || !this.$v.feeAgencia.minValue) {
              this.feeAgenciaInvalidoMsj = 'El fee de agencia ingresado no es válido';
            }      
          }     
        } else {
          this.feeAgenciaValido = null;
          this.feeAgenciaInvalidoMsj = '';
        }
      }

      if (campo == 'feeAgenciaPremios' || validarTodos) {
        if (this.$v.feeAgenciaPremios.$error) {
          this.feeAgenciaPremiosValido = false;
          if (!this.$v.feeAgenciaPremios.decimal) {
            this.feeAgenciaPremiosInvalidoMsj = 'El fee de agencia de premios debe ser un valor numérico';
          } else {
            if (!this.$v.feeAgenciaPremios.maxValue || !this.$v.feeAgenciaPremios.minValue) {
              this.feeAgenciaPremiosInvalidoMsj = 'El fee de agencia de premios ingresado no es válido';
            }      
          }     
        } else {
          this.feeAgenciaPremiosValido = null;
          this.feeAgenciaPremiosInvalidoMsj = '';
        }
      }

      if (campo == 'pjeFinanciacion' || validarTodos) {
        if (this.$v.pjeFinanciacion.$error) {
          this.pjeFinanciacionValido = false;
          if (!this.$v.pjeFinanciacion.decimal) {
            this.pjeFinanciacionInvalidoMsj = 'El fee de agencia debe ser un valor numérico';
          } else {
            if (!this.$v.pjeFinanciacion.maxValue || !this.$v.pjeFinanciacion.minValue) {
              this.pjeFinanciacionInvalidoMsj = 'El fee de agencia ingresado no es válido';
            }      
          }     
        } else {
          this.pjeFinanciacionValido = null;
          this.pjeFinanciacionInvalidoMsj = '';
        }
      }

      if (campo == 'pjeRecargoServicioPropio' || validarTodos) {
        if (this.$v.pjeRecargoServicioPropio.$error) {
          this.pjeRecargoServicioPropioValido = false;
          if (!this.$v.pjeRecargoServicioPropio.decimal) {
            this.pjeRecargoServicioPropioInvalidoMsj = 'El porcentaje de recargo debe ser un valor numérico';
          } else {
            if (!this.$v.pjeRecargoServicioPropio.maxValue || !this.$v.pjeRecargoServicioPropio.minValue) {
              this.pjeRecargoServicioPropioInvalidoMsj = 'El porcentaje de recargo ingresado no es válido';
            }      
          }     
        } else {
          this.pjeRecargoServicioPropioValido = null;
          this.pjeRecargoServicioPropioInvalidoMsj = '';
        }
      }

      if (campo == 'pjeMargenMinimoCotizacion' || validarTodos) {
        if (this.$v.pjeMargenMinimoCotizacion.$error) {
          this.pjeMargenMinimoCotizacionValido = false;
          if (!this.$v.pjeMargenMinimoCotizacion.decimal) {
            this.pjeMargenMinimoCotizacionInvalidoMsj = 'El porcentaje debe ser un valor numérico';
          } else {
            if (!this.$v.pjeMargenMinimoCotizacion.maxValue || !this.$v.pjeMargenMinimoCotizacion.minValue) {
              this.pjeMargenMinimoCotizacionInvalidoMsj = 'El porcentaje ingresado no es válido';
            }      
          }     
        } else {
          this.pjeMargenMinimoCotizacionValido = null;
          this.pjeMargenMinimoCotizacionInvalidoMsj = '';
        }
      }

      if (campo == 'pjeMargenMinimoCotizacionPropio' || validarTodos) {
        if (this.$v.pjeMargenMinimoCotizacionPropio.$error) {
          this.pjeMargenMinimoCotizacionPropioValido = false;
          if (!this.$v.pjeMargenMinimoCotizacionPropio.decimal) {
            this.pjeMargenMinimoCotizacionPropioInvalidoMsj = 'El porcentaje debe ser un valor numérico';
          } else {
            if (!this.$v.pjeMargenMinimoCotizacionPropio.maxValue || !this.$v.pjeMargenMinimoCotizacionPropio.minValue) {
              this.pjeMargenMinimoCotizacionPropioInvalidoMsj = 'El porcentaje ingresado no es válido';
            }      
          }     
        } else {
          this.pjeMargenMinimoCotizacionPropioValido = null;
          this.pjeMargenMinimoCotizacionPropioInvalidoMsj = '';
        }
      }

      if (campo == 'pjeMargenMinimoCotizacionTerceros' || validarTodos) {
        if (this.$v.pjeMargenMinimoCotizacionTerceros.$error) {
          this.pjeMargenMinimoCotizacionTercerosValido = false;
          if (!this.$v.pjeMargenMinimoCotizacionTerceros.decimal) {
            this.pjeMargenMinimoCotizacionTercerosInvalidoMsj = 'El porcentaje debe ser un valor numérico';
          } else {
            if (!this.$v.pjeMargenMinimoCotizacionTerceros.maxValue || !this.$v.pjeMargenMinimoCotizacionTerceros.minValue) {
              this.pjeMargenMinimoCotizacionTercerosInvalidoMsj = 'El porcentaje ingresado no es válido';
            }      
          }     
        } else {
          this.pjeMargenMinimoCotizacionTercerosValido = null;
          this.pjeMargenMinimoCotizacionTercerosInvalidoMsj = '';
        }
      }

      if (campo == 'pjeGastosFijos' || validarTodos) {
        if (this.$v.pjeGastosFijos.$error) {
          this.pjeGastosFijosValido = false;
          if (!this.$v.pjeGastosFijos.decimal) {
            this.pjeGastosFijosInvalidoMsj = 'El porcentaje de gastos fijos debe ser un valor numérico';
          } else {
            if (!this.$v.pjeGastosFijos.maxValue || !this.$v.pjeRecargoServicioPropio.minValue) {
              this.pjeGastosFijosInvalidoMsj = 'El porcentaje de gastos fijos ingresado no es válido';
            }      
          }     
        } else {
          this.pjeGastosFijosValido = null;
          this.pjeGastosFijosInvalidoMsj = '';
        }
      }

      if (campo == 'pjeInversionFutura' || validarTodos) {
        if (this.$v.pjeInversionFutura.$error) {
          this.pjeInversionFuturaValido = false;
          if (!this.$v.pjeInversionFutura.decimal) {
            this.pjeInversionFuturaInvalidoMsj = 'El porcentaje de inversión futura debe ser un valor numérico';
          } else {
            if (!this.$v.pjeInversionFutura.maxValue || !this.$v.pjeRecargoServicioPropio.minValue) {
              this.pjeInversionFuturaInvalidoMsj = 'El porcentaje de inversión futura ingresado no es válido';
            }      
          }     
        } else {
          this.pjeInversionFuturaValido = null;
          this.pjeInversionFuturaInvalidoMsj = '';
        }
      }

      if (campo == 'pjeImpuestosInternos' || validarTodos) {
        if (this.$v.pjeImpuestosInternos.$error) {
          this.pjeImpuestosInternosValido = false;
          if (!this.$v.pjeImpuestosInternos.decimal) {
            this.pjeImpuestosInternosInvalidoMsj = 'El porcentaje de impuestos internos debe ser un valor numérico';
          } else {
            if (!this.$v.pjeImpuestosInternos.maxValue || !this.$v.pjeRecargoServicioPropio.minValue) {
              this.pjeImpuestosInternosInvalidoMsj = 'El porcentaje de impuestos internos ingresado no es válido';
            }      
          }     
        } else {
          this.pjeImpuestosInternosValido = null;
          this.pjeImpuestosInternosInvalidoMsj = '';
        }
      }

      if (campo == 'plazoPago' || validarTodos) {
        if (this.$v.plazoPago.$error) {
          this.plazoPagoValido = false;
          if (!this.$v.plazoPago.numeric) {
            this.plazoPagoInvalidoMsj = 'El plazo de pago debe ser un valor numérico';
          } else {
            if (!this.$v.plazoPago.maxValue || !this.$v.plazoPago.minValue) {
              this.plazoPagoInvalidoMsj = 'El plazo de pago ingresado no es válido';
            }      
          }     
        } else {
          this.plazoPagoValido = null;
          this.plazoPagoInvalidoMsj = '';
        }
      }

      if (campo == 'numeroProveedor' || validarTodos) {
        if (this.$v.numeroProveedor.$error) {
          this.numeroProveedorValido = false;
          if (!this.$v.numeroProveedor.maxLength) {
            this.numeroProveedorInvalidoMsj = 'El número de proveedor sólo puede contener hasta 20 caracteres';
          }
        } else {
          this.numeroProveedorValido = null;
          this.numeroProveedorInvalidoMsj = '';
        }
      }

      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones solo pueden contener hasta 50.000 caracteres';
          }      
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let save = Boolean(true);

      let pais = null;
      if (this.paisNombre) {
        pais = this.getSelected(this.paises, this.paisNombre);
      }
      this.$store.dispatch('cliente/setPais', pais);

      let provincia = null;
      if (this.provinciaNombre) {
        provincia = this.getSelected(this.provincias, this.provinciaNombre);
      }
      this.$store.dispatch('cliente/setProvincia', provincia);

      let localidad = null;
      if (this.localidadNombre) {
        localidad = this.getSelected(this.localidades, this.localidadNombre);
      }
      this.$store.dispatch('cliente/setLocalidad', localidad);

      let condicionFiscal = null;
      if (this.condicionFiscalNombre) {
        condicionFiscal = this.getSelected(this.condicionesFiscales, this.condicionFiscalNombre);
      }
      this.$store.dispatch('cliente/setCondicionFiscal', condicionFiscal);

      let condicionFiscalError = Boolean(true);
      if (this.condicionFiscal) {
        if (this.condicionFiscal.id) {
          if (this.condicionFiscal.id != 0) {
            condicionFiscalError = Boolean(false);
          }
        }
      }
      if (condicionFiscalError) {
        save = Boolean(false);
        this.condicionFiscalValida = false;
        this.condicionFiscalInvalidaMsj = 'Debe seleccionar la condición fiscal del cliente';
      }

      let documentoTipo = null;
      if (this.documentoTipoNombre) {
        documentoTipo = this.getSelected(this.documentosTipos, this.documentoTipoNombre);
      }
      this.$store.dispatch('cliente/setDocumentoTipo', documentoTipo);

      let documentoTipoError = Boolean(true);
      if (this.documentoTipo) {
        if (this.documentoTipo.id) {
          if (this.documentoTipo.id != 0) {
            documentoTipoError = Boolean(false);
          }
        }
      }
      if (documentoTipoError) {
        save = Boolean(false);
        this.documentoTipoValido = false;
        this.documentoTipoInvalidoMsj = 'Debe seleccionar el tipo de identificación.';
      }

      let formaPago = null;
      if (this.formaPagoNombre) {
        formaPago = this.getSelected(this.formasPago, this.formaPagoNombre);
      }
      this.$store.dispatch('cliente/setFormaPago', formaPago);

      if (this.giroEmpresaVisible) {
        let giroEmpresa = null;
        if (this.giroEmpresaNombre) {
          giroEmpresa = this.getSelected(this.girosEmpresas, this.giroEmpresaNombre);
        }
        this.$store.dispatch('cliente/setGiroEmpresa', giroEmpresa);
  
        let giroEmpresaError = Boolean(true);
        if (this.giroEmpresa) {
          if (this.giroEmpresa.id) {
            if (this.giroEmpresa.id != 0) {
              giroEmpresaError = Boolean(false);
            }
          }
        }
        if (giroEmpresaError) {
          save = Boolean(false);
          this.giroEmpresaValido = false;
          this.giroEmpresaInvalidoMsj = 'Debe seleccionar el giro de la empresa.';
        }
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('cliente/save')
            .then(()  => this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        }
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    goList() {
      this.$router.push({ name: "Clientes" });
    },
    condicionFiscalActualizada(condicionFiscalNombre) {
      this.condicionFiscalNombre = condicionFiscalNombre;
      if (this.condicionFiscalNombre) {
        this.condicionFiscalValida = null;
        this.condicionFiscalInvalidaMsj = '';
      }
    },
    documentoTipoActualizado(documentoTipoNombre) {
      this.documentoTipoNombre = documentoTipoNombre;
      if (this.documentoTipoNombre) {
        this.documentoTipoValido = null;
        this.documentoTipoInvalidoMsj = '';
      }
    },
    paisActualizado(paisNombre) {
      if (!this.loadingPaises) {
        this.paisNombre = paisNombre;
        this.provinciaNombre = null;
        this.localidadNombre = null;
        this.getProvincias();
        this.getLocalidades();
        
        this.paisValido = null;
        this.paisInvalidoMsj = '';
      }
    },
    provinciaActualizada(provinciaNombre) {
      if (!this.loadingProvincias) {
        this.provinciaNombre = provinciaNombre;
        this.localidadNombre = null;
        this.getLocalidades();

        this.provinciaValida = null;
        this.provinciaInvalidaMsj = '';
      }
    },
    localidadActualizada(localidadNombre) {
      this.localidadNombre = localidadNombre;
      if (this.localidadNombre) {
        this.localidadValida = null;
        this.localidadInvalidaMsj = '';
      }
    },
    addLocalidad() {
      let addLocalidad = false;
      let provincia = null;

      if (this.provinciaNombre) {
        provincia = this.getSelected(this.provincias, this.provinciaNombre);
        this.$store.dispatch('cliente/setProvincia', provincia);

        if (this.provincia) {
          if (this.provincia.id != 0) {
            addLocalidad = true;
          }
        }
      }

      if (addLocalidad) {
        this.$refs.localidadModal.show();
      } else {
        this.modalOkAction = null;
        this.modalHiddenAction = null;
        this.modalMensaje = 'Seleccione en primer término la provincia correspondiente';
        this.modalMsj = true;
      }      
    },
    updateLocalidades(localidadNombre) {
      this.$refs.localidadModal.hide()
      this.getLocalidades();
      this.localidadNombre = localidadNombre.trim();
    },
    closeLocalidad() {
      this.$refs.localidadModal.hide()
    },
    formaPagoActualizada(formaPagoNombre) {
      this.formaPagoNombre = formaPagoNombre;
    },
    giroEmpresaActualizado(giroEmpresaNombre) {
      this.giroEmpresaNombre = giroEmpresaNombre;
      
      this.giroEmpresaValido = null;
      this.giroEmpresaInvalidoMsj = '';
    },
    agregarEscalaFee() {
      this.escalaFee = null;
      this.$refs.escalaFeeModal.show();
    },
    editarEscalaFee(item) {
      this.escalaFee = item;
      this.$refs.escalaFeeModal.show();
    },
    eliminarEscalaFee(item) {
      this.$store.dispatch('cliente/removeEscalaFee', item.id)
        .catch(error => this.showErrorMsj(error));
    },
    updateEscalaFee(escalaFee) {
      this.$refs.escalaFeeModal.hide();

      if (this.escalaFee) {
        this.escalaFee.montoMinimo = parseFloat(escalaFee.montoMinimo);
        this.escalaFee.montoMaximo = parseFloat(escalaFee.montoMaximo);
        this.escalaFee.pjeFeeAgencia = parseFloat(escalaFee.pjeFeeAgencia);
      } else {
        escalaFee = {
          montoMinimo: escalaFee.montoMinimo,
          montoMaximo: escalaFee.montoMaximo,
          pjeFeeAgencia: escalaFee.pjeFeeAgencia
        }
        this.$store.dispatch('cliente/addEscalaFee', escalaFee)
          .catch(error => this.showErrorMsj(error));
      }
    },
    closeEscalaFee() {
      this.$refs.escalaFeeModal.hide();
    },
    agregarEscalaFinanciacion() {
      this.escalaFinanciacion = null;
      this.$refs.escalaFinanciacionModal.show();
    },
    editarEscalaFinanciacion(item) {
      this.escalaFinanciacion = item;
      this.$refs.escalaFinanciacionModal.show();
    },
    eliminarEscalaFinanciacion(item) {
      this.$store.dispatch('cliente/removeEscalaFinanciacion', item.id)
        .catch(error => this.showErrorMsj(error));
    },
    updateEscalaFinanciacion(escalaFinanciacion) {
      this.$refs.escalaFinanciacionModal.hide();

      if (this.escalaFinanciacion) {
        this.escalaFinanciacion.montoMinimo = parseFloat(escalaFinanciacion.montoMinimo);
        this.escalaFinanciacion.montoMaximo = parseFloat(escalaFinanciacion.montoMaximo);
        this.escalaFinanciacion.pjeFinanciacion = parseFloat(escalaFinanciacion.pjeFinanciacion);
      } else {
        escalaFinanciacion = {
          montoMinimo: escalaFinanciacion.montoMinimo,
          montoMaximo: escalaFinanciacion.montoMaximo,
          pjeFinanciacion: escalaFinanciacion.pjeFinanciacion
        }
        this.$store.dispatch('cliente/addEscalaFinanciacion', escalaFinanciacion)
          .catch(error => this.showErrorMsj(error));
      }
    },
    closeEscalaFinanciacion() {
      this.$refs.escalaFinanciacionModal.hide();
    }
  },
  validations() {
    return {
      nombreComercial: {
        required,
        maxLength: maxLength(75)
      },
      razonSocial: {
        required,
        maxLength: maxLength(75)
      },
      documentoNumero: {
        required: requiredIf(function () {
          var isRequired = true;

          if (this.condicionFiscalNombre) {
            var condicionFiscal = this.getSelected(this.condicionesFiscales, this.condicionFiscalNombre);
            if (condicionFiscal) {
              if (condicionFiscal.id == 3) {
                isRequired = false;
              }
            }
          }
          return isRequired;
        }),
        DocumentoValido,
        maxLength: maxLength(20)
        // numeric,
      },
      direccion: {
        maxLength: maxLength(150)
      },
      codigoPostal: {
        maxLength: maxLength(8)
      },
      telefono: {
        maxLength: maxLength(50)
      },
      celular: {
        maxLength: maxLength(50)
      },
      email: {
        email,
        maxLength: maxLength(150)
      },
      email2: {
        email,
        maxLength: maxLength(150)
      },
      feeAgencia: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(999)
      },
      feeAgenciaPremios: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(999)
      },
      pjeFinanciacion: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(999)
      },
      pjeRecargoServicioPropio: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(999)
      },
      pjeMargenMinimoCotizacion: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(999)
      } ,
      pjeMargenMinimoCotizacionPropio: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(999)
      },
      pjeMargenMinimoCotizacionTerceros: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(999)
      },
      pjeGastosFijos: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(999)
      },
      pjeInversionFutura: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(999)
      },
      pjeImpuestosInternos: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(999)
      },
      plazoPago: {
        numeric,
        minValue: minValue(0),
        maxValue: maxValue(9999)
      },
      numeroProveedor: {
        maxLength: maxLength(20)
      },
      observaciones: {
        maxLength: maxLength(50000)
      },
    }
  },  
}
</script>

<style>
</style>
